(function () {
  function initShopLook(root) {
    if (!root || root.dataset.shopLookBound === 'true') return;
    root.dataset.shopLookBound = 'true';

    var hotspots = Array.prototype.slice.call(root.querySelectorAll('[data-shop-look-hotspot]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-shop-look-panel]'));
    var activeId = '';
    var activeTrigger = null;
    var initialHotspot = hotspots.find(function (hotspot) {
      return hotspot.dataset.shopLookExpanded === 'true';
    });

    function getActivePopup(id) {
      var hotspot = hotspots.find(function (candidate) {
        return candidate.dataset.shopLookId === id;
      });
      var panel = panels.find(function (candidate) {
        return candidate.dataset.shopLookId === id;
      });
      var inlineContent = hotspot && hotspot.querySelector('.shop-look__label-content');
      var useInlineContent = inlineContent && window.getComputedStyle(inlineContent).display !== 'none';
      return useInlineContent ? inlineContent : panel;
    }

    function getPopupActions(container) {
      if (!container) return [];
      return Array.prototype.slice.call(container.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      ));
    }

    function focusActivePopup(id) {
      window.requestAnimationFrame(function () {
        var container = getActivePopup(id);
        if (container) container.focus({ preventScroll: true });
      });
    }

    function setActive(id, options) {
      options = options || {};
      activeId = id || '';

      hotspots.forEach(function (hotspot) {
        var isActive = hotspot.dataset.shopLookId === activeId;
        var triggers = hotspot.querySelectorAll('[data-shop-look-trigger]');
        hotspot.classList.toggle('is-active', isActive);
        triggers.forEach(function (trigger) {
          trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        });
        hotspot.querySelectorAll('.shop-look__label-content').forEach(function (content) {
          content.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          content.toggleAttribute('inert', !isActive);
        });
      });

      panels.forEach(function (panel) {
        var isActive = panel.dataset.shopLookId === activeId;
        panel.classList.toggle('is-active', isActive);
        panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        panel.toggleAttribute('inert', !isActive);
      });

      root.classList.toggle('has-active-panel', Boolean(activeId));
      if (activeId && options.focusPopup) focusActivePopup(activeId);
      if (!activeId && options.restoreFocus && activeTrigger && activeTrigger.isConnected) {
        activeTrigger.focus({ preventScroll: true });
      }
      if (!activeId) activeTrigger = null;
    }
    root.shopLookSetActive = setActive;

    function toggleHotspot(hotspot, trigger) {
      if (!hotspot) return;
      var id = hotspot.dataset.shopLookId;
      if (activeId === id) {
        setActive('', { restoreFocus: true });
        return;
      }
      activeTrigger = trigger;
      setActive(id, { focusPopup: true });
    }

    root.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-shop-look-trigger]');
      if (!trigger || !root.contains(trigger)) return;
      event.preventDefault();
      toggleHotspot(trigger.closest('[data-shop-look-hotspot]'), trigger);
    });

    document.addEventListener('click', function (event) {
      if (!activeId || root.contains(event.target)) return;
      setActive('');
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Tab' && activeId) {
        var popup = getActivePopup(activeId);
        var actions = getPopupActions(popup);
        var current = document.activeElement;
        var firstAction = actions[0];
        var lastAction = actions[actions.length - 1];
        var activeHotspotIndex = hotspots.findIndex(function (hotspot) {
          return hotspot.dataset.shopLookId === activeId;
        });
        var nextHotspot = activeHotspotIndex >= 0 ? hotspots[activeHotspotIndex + 1] : null;
        var nextTrigger = nextHotspot && nextHotspot.querySelector('[data-shop-look-trigger]');

        if (!event.shiftKey && firstAction && (current === activeTrigger || current === popup)) {
          event.preventDefault();
          firstAction.focus({ preventScroll: true });
          return;
        }

        if (!event.shiftKey && lastAction && nextTrigger && current === lastAction) {
          event.preventDefault();
          setActive('');
          nextTrigger.focus({ preventScroll: true });
          return;
        }

        if (event.shiftKey && activeTrigger && (current === popup || current === firstAction)) {
          event.preventDefault();
          activeTrigger.focus({ preventScroll: true });
          return;
        }

      }

      if (event.key === 'Escape' && activeId) setActive('', { restoreFocus: true });
    });

    if (initialHotspot) {
      setActive(initialHotspot.dataset.shopLookId);
    } else if (root.dataset.shopLookStyle === 'thumbnail_panel' && root.dataset.openFirst === 'true' && hotspots[0]) {
      setActive(hotspots[0].dataset.shopLookId);
    }
  }

  function initScope(scope) {
    (scope || document).querySelectorAll('[data-shop-look-root]').forEach(initShopLook);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initScope(document);
    });
  } else {
    initScope(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initScope(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var hotspot = event.target && event.target.closest ? event.target.closest('[data-shop-look-hotspot]') : null;
    if (!hotspot) return;
    var root = hotspot.closest('[data-shop-look-root]');
    if (!root) return;
    initShopLook(root);
    if (typeof root.shopLookSetActive === 'function') {
      root.shopLookSetActive(hotspot.dataset.shopLookId);
    }
  });
})();
